import { $ as $effect, f as fail, s as succeed, a as fromAsync, b as $next, c as some, n as none, p as pipe, m as map, d as succeedAsync, e as $exec, t as trySync, g as tryPromise } from '../lib/tools-C0injSjT.mjs';
export { U as UnknownError, v as failAsync, w as failAsyncWith, M as flatMap, N as flatMapSpread, z as fromBoolean, A as fromCoerced, x as fromCondition, C as fromExpression, y as fromNullable, B as invert, q as left, J as mapAsync, L as mapAsyncSpread, O as mapError, P as mapErrorAsync, i as mapErrorDefault, h as mapErrorPassThrough, K as mapSpread, Q as pipeMap, l as promise, o as promiseEffect, G as promiseEffectImmediate, F as promiseImmediate, R as returnsEffect, r as right, u as succeedAsyncWith, j as sync, k as syncEffect, E as syncEffectImmediate, D as syncImmediate, I as tryPromiseImmediate, H as trySyncImmediate } from '../lib/tools-C0injSjT.mjs';
import { l as limit2 } from '../lib/limit2-B1aIcHAv.mjs';
import '../lib/array-DNG3qZDq.mjs';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class AggregatedError extends AggregateError {
  /**
 *
 *
 *
 *
 */
  constructor(errors, message) {
    super(errors, message);
    __publicField(this, "name", "AggregatedError");
    /**
 *
 */
    __publicField(this, "errors");
    this.errors = [...errors];
  }
  static stringifyError(expand, e) {
    if (e instanceof AggregatedError) return e.toString(expand);
    if (e instanceof Error) return e.stack ?? e.message;
    return `${e}`;
  }
  /**
 *
 *
 *
 *
 */
  toString(expand = false) {
    if (!expand || this.errors.length === 0) {
      return super.toString();
    }
    const message = this.stack ?? super.toString();
    const msgs = this.errors.map(AggregatedError.stringifyError.bind(this, expand)).join(`
${"-".repeat(10)}
`).split("\n").map((m) => `    ${m}`).join("\n");
    return `${message}

  Aggregated Errors:

${msgs}`;
  }
}

function aggregateFailures(results, message) {
  const failed = results.filter((res) => res[$effect] === "left");
  return failed.length > 0 ? fail(
    new AggregatedError(
      failed.map(([error]) => error),
      message ?? "One or more effects failed to resolve"
    )
  ) : succeed(results.map(([, value]) => value));
}

function allSync(effects, options = {}) {
  return aggregateFailures(effects, options.message);
}
function allAsync(effects, options = {}) {
  return fromAsync(Promise.all(effects).then((v) => aggregateFailures(v, options.message)));
}

function catchError(handler) {
  const onFailure = (e) => handler(e.left);
  return (effect) => effect[$next](void 0, onFailure);
}
const catchFailure = catchError;
function catchErrorAsync(handler) {
  const onFailure = (e) => fromAsync(handler(e.left));
  return (effect) => effect[$next](void 0, onFailure);
}
function catchType(type, handler) {
  const onFailure = (e) => e.left instanceof type ? handler(e.left) : e;
  return (effect) => effect[$next](void 0, onFailure);
}
function catchTypeAsync(type, handler) {
  const onFailure = (e) => e.left instanceof type ? fromAsync(handler(e.left)) : e;
  return (effect) => effect[$next](void 0, onFailure);
}
function catchName(name, handler) {
  const onFailure = (e) => {
    const err = e.left;
    return typeof err === "object" && !!err && "name" in err && err.name === name ? handler(err) : e;
  };
  return (effect) => effect[$next](void 0, onFailure);
}
function catchNameAsync(name, handler) {
  const onFailure = (e) => {
    const err = e.left;
    return typeof err === "object" && !!err && "name" in err && err.name === name ? fromAsync(handler(err)) : e;
  };
  return (effect) => effect[$next](void 0, onFailure);
}
function catchSome(handler) {
  const onFailure = (e) => {
    const res = handler(e.left);
    return res[$effect] === "right" ? res[1] : e;
  };
  return (effect) => effect[$next](void 0, onFailure);
}

const pushWithOptions = (array, value, flatValue) => {
  array.push(...flatValue && Array.isArray(value) ? value : [value]);
};
function concatenate(input, result, options) {
  const { flatInput = true, flatResult = true } = options;
  const resultArray = [];
  pushWithOptions(resultArray, input, flatInput);
  pushWithOptions(resultArray, result, flatResult);
  return succeed(resultArray);
}
function mapConcat(mapper, options = {}) {
  const onSuccess = (e) => concatenate(e[1], mapper(e[1]), options);
  return (effect) => effect[$next](onSuccess);
}
function mapConcatSpread(mapper, options = {}) {
  const onSuccess = (e) => concatenate(e[1], mapper(...e[1]), options);
  return (effect) => effect[$next](onSuccess);
}
function mapConcatAsync(mapper, options = {}) {
  const onSuccess = (e) => fromAsync(mapper(e[1]).then((result) => concatenate(e[1], result, options)));
  return (effect) => effect[$next](onSuccess);
}
function mapConcatAsyncSpread(mapper, options = {}) {
  const onSuccess = (e) => fromAsync(mapper(...e[1]).then((result) => concatenate(e[1], result, options)));
  return (effect) => effect[$next](onSuccess);
}
function flatMapConcat(mapper, options = {}) {
  const onSuccess = (e) => (
    /*                                                             */
    mapper(e[1])[$next]((re) => concatenate(e[1], re[1], options))
  );
  return (effect) => effect[$next](onSuccess);
}
function flatMapConcatSpread(mapper, options = {}) {
  const onSuccess = (e) => (
    /*                                                      */
    mapper(...e[1])[$next]((re) => concatenate(e[1], re[1], options))
  );
  return (effect) => effect[$next](onSuccess);
}

function isRight(effect) {
  return effect[$effect] === "right";
}
const isSome = isRight;
const isSuccess = isRight;
function isLeft(effect) {
  return effect[$effect] === "left";
}
const isNone = isLeft;
const isFailure = isLeft;

function mapIf(handler) {
  return (effect) => effect[$next]((e) => e[1] ? handler.onTrue() : handler.onFalse());
}
function ifImmediate(condition, {
  onTrue,
  onFalse
}) {
  return mapIf({ onTrue, onFalse })(succeed(condition));
}
function mapIfEffect(condition, handler) {
  const onSucceed = (e) => condition ? handler.onTrue(e[1]) : handler.onFalse(e[1]);
  return (effect) => effect[$next](onSucceed);
}
function when(predicate) {
  const onSucceed = (e) => succeed(predicate(e[1]) ? some(e[1]) : none());
  return (effect) => effect[$next](onSucceed);
}
function whenEffect(predicate) {
  const onSucceed = (e) => {
    return pipe(
      predicate(e[1]),
      map((p) => p ? succeed(e[1]) : fail(void 0))
    );
  };
  return (effect) => effect[$next](onSucceed);
}
function unless(predicate) {
  const onSucceed = (e) => succeed(predicate(e[1]) ? fail(void 0) : succeed(e[1]));
  return (effect) => effect[$next](onSucceed);
}

function mapEach(mapper) {
  const onSuccess = (e) => succeed(e[1].map(mapper));
  return (effect) => effect[$next](onSuccess);
}
function mapEachAsync(mapper) {
  const onSuccess = (e) => succeedAsync(Promise.all(e[1].map(mapper)));
  return (effect) => effect[$next](onSuccess);
}
function mapEachLimit(mapper, options) {
  const onSuccess = (e) => succeedAsync(limit2(e[1], mapper, options));
  return (effect) => effect[$next](onSuccess);
}
function flatMapEach(mapper, options) {
  const onSuccess = (e) => {
    const r = e[1].map(mapper);
    if (r[0] && r[0][$exec] === "async") {
      return fromAsync(
        Promise.all(r).then(
          (re) => aggregateFailures(re, options?.message)
        )
      );
    }
    return aggregateFailures(r, options?.message);
  };
  return (effect) => effect[$next](onSuccess);
}
function flatMapEachLimit(mapper, options) {
  const onSuccess = (e) => fromAsync(limit2(e[1], mapper, options).then((v) => aggregateFailures(v, options?.message)));
  return (effect) => effect[$next](onSuccess);
}

function match(param) {
  const onSucceedWrapper = (e) => succeed(param.onSucceed(e[1]));
  const onFailWrapper = (e) => succeed(param.onFail(e[0]));
  return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}
function matchAsync(param) {
  const onSucceedWrapper = (e) => succeedAsync(param.onSucceed(e[1]));
  const onFailWrapper = (e) => succeedAsync(param.onFail(e[0]));
  return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}
function matchEffect(param) {
  const onSucceedWrapper = (e) => param.onSucceed(e[1]);
  const onFailWrapper = (e) => param.onFail(e[0]);
  return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}

function policy(options) {
  if (Object.values(options).every((v) => v === void 0)) {
    throw new Error("You must provide at least one option to the policy function");
  }
  const { times = 0, delay = 0 } = options;
  let currentRetry = 0;
  const until = options.until ?? (() => times && currentRetry >= times);
  return (failure) => {
    currentRetry += 1;
    return until(failure[0]) ? failure : succeedAsync(
      new Promise((r) => {
        if (delay) {
          setTimeout(() => r(true), delay);
          return;
        }
        r(true);
      })
    );
  };
}
function retry(task, retryPolicy) {
  const retrier = async (args) => {
    const errors = [];
    while (true) {
      const res = await task(...args);
      if (isSuccess(res)) {
        return res;
      }
      errors.push(res[0]);
      const policyRes = await retryPolicy(res);
      if (isFailure(policyRes)) {
        return fail(
          new AggregatedError(
            [...errors, policyRes[0]],
            `Retry operation failed with last failure being: ${policyRes[0]}`
          )
        );
      }
    }
  };
  return (...args) => fromAsync(retrier(args));
}

function tap(handler) {
  const onSucceed = (e) => (handler(e[1]), e);
  return (effect) => effect[$next](onSucceed);
}
function tapSpread(handler) {
  const onSucceed = (e) => (handler(...e[1]), e);
  return (effect) => effect[$next](onSucceed);
}
function tapAsync(handler) {
  const onSucceed = (e) => fromAsync(handler(e[1]).then(() => e));
  return (effect) => effect[$next](onSucceed);
}
function tapAsyncSpread(handler) {
  const onSucceed = (e) => fromAsync(handler(...e[1]).then(() => e));
  return (effect) => effect[$next](onSucceed);
}
function tapError(handler) {
  const onFail = (e) => (handler(e[0]), e);
  return (effect) => effect[$next](void 0, onFail);
}
function tapErrorAsync(handler) {
  const onFail = (e) => fromAsync(handler(e[0]).then(() => e));
  return (effect) => effect[$next](void 0, onFail);
}

function tryMap(mapper, mapErr) {
  const onSuccess = trySync((e) => mapper(e[1]), mapErr);
  return (effect) => effect[$next](onSuccess);
}
function tryMapSpread(mapper, mapErr) {
  const onSuccess = trySync((e) => mapper(...e[1]), mapErr);
  return (effect) => effect[$next](onSuccess);
}
function tryMapAsync(mapper, mapErr) {
  const onSuccess = tryPromise((e) => mapper(e[1]), mapErr);
  return (effect) => effect[$next](onSuccess);
}
function tryMapAsyncSpread(mapper, mapErr) {
  const onSuccess = tryPromise((e) => mapper(...e[1]), mapErr);
  return (effect) => effect[$next](onSuccess);
}

function unbox(unboxer = (_) => _) {
  return (effect) => effect[$exec] === "async" ? effect.then((e) => unboxer(e[0] ?? e[1])) : unboxer(effect[0] ?? effect[1]);
}
function unboxThrow(unboxer = (_) => _) {
  const valueOrThrow = (effect) => {
    if (effect[0]) {
      throw effect[0];
    }
    return unboxer(effect[1]);
  };
  return (effect) => effect[$exec] === "async" ? effect.then(valueOrThrow) : valueOrThrow(effect);
}

export { AggregatedError, allAsync, allSync, catchError, catchErrorAsync, catchFailure, catchName, catchNameAsync, catchSome, catchType, catchTypeAsync, fail, flatMapConcat, flatMapConcatSpread, flatMapEach, flatMapEachLimit, ifImmediate, isFailure, isLeft, isNone, isRight, isSome, isSuccess, map, mapConcat, mapConcatAsync, mapConcatAsyncSpread, mapConcatSpread, mapEach, mapEachAsync, mapEachLimit, mapIf, mapIfEffect, match, matchAsync, matchEffect, none, pipe, policy, retry, some, succeed, succeedAsync, tap, tapAsync, tapAsyncSpread, tapError, tapErrorAsync, tapSpread, tryMap, tryMapAsync, tryMapAsyncSpread, tryMapSpread, tryPromise, trySync, unbox, unboxThrow, unless, when, whenEffect };
/*                              */
